import { render } from "./AddGoods.vue?vue&type=template&id=69fe1231&scoped=true"
import script from "./AddGoods.vue?vue&type=script&lang=js"
export * from "./AddGoods.vue?vue&type=script&lang=js"

import "./AddGoods.vue?vue&type=style&index=0&id=69fe1231&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69fe1231"]])

export default __exports__